var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { getResourceName } from '@/shared/components/ResourceName';
import { displayDaysAndTime, getTimeAbbr } from '@/shared/utils/absenceFormat';
import DashboardTile from './DashboardTile';
import messages from '../../dashboardMessages';
var formatValue = function (inDays, hours, wholeDays, remainderMinutes, abbr) {
    return inDays ? displayDaysAndTime(wholeDays, remainderMinutes, abbr) : (hours !== null && hours !== void 0 ? hours : 0).toTime();
};
var DashboardAbsenceTile = function (_a) {
    var _b, _c, _d;
    var data = _a.data, className = _a.className, intl = _a.intl, inDays = _a.inDays;
    var title = getResourceName(intl, data.resource);
    var abbr = getTimeAbbr(intl, messages);
    var balanceCompound = displayDaysAndTime(data.balanceWholeDays, data.balanceRemainderMinutes, abbr);
    var startCompound = displayDaysAndTime(data.startValueWholeDays, data.startValueRemainderMinutes, abbr);
    var value = data.startValue !== null ? (_jsxs("span", __assign({ title: intl.formatMessage(messages.CounterBalanceStartValue, {
            balanceDays: balanceCompound,
            balanceHours: ((_b = data.balance) !== null && _b !== void 0 ? _b : 0).toTime(),
            startValueHours: ((_c = data.startValue) !== null && _c !== void 0 ? _c : 0).toTime(),
            startValueDays: startCompound,
        }) }, { children: [formatValue(inDays, data.balance, data.balanceWholeDays, data.balanceRemainderMinutes, abbr), "\u00A0/\u00A0", formatValue(inDays, data.startValue, data.startValueWholeDays, data.startValueRemainderMinutes, abbr)] }))) : (_jsx("span", __assign({ title: intl.formatMessage(messages.AbsenceWidgetWithoutCounterTooltip, {
            balanceDays: balanceCompound,
            balanceHours: ((_d = data.balance) !== null && _d !== void 0 ? _d : 0).toTime(),
        }) }, { children: formatValue(inDays, data.balance, data.balanceWholeDays, data.balanceRemainderMinutes, abbr) })));
    return _jsx(DashboardTile, { title: title, value: value || 0, titleClassName: className });
};
export default DashboardAbsenceTile;
